<div class="fixed inset-0 z-[2100] h-full w-full bg-gray-dark opacity-90"></div>
<div class="fixed inset-0 z-[2300] mx-auto my-auto flex h-full w-1/2 flex-col items-center justify-center opacity-100">
    <img alt="" src="/assets/img/error.gif" />
    <je-message-box [type]="'error'">
        <span>
            <h2 class="mb-3 text-lg text-blue">{{ 'CRITICAL_ERROR_HEADER' | translate }}</h2>
            <p>{{ errorTranslateKey | translate }}</p>
            <p class="mt-2">{{ remainingTime }} {{ 'CRITICAL_ERROR_REMAINING_TIME' | translate }}</p>
            <je-button [label]="'CRITICAL_ERROR_BUTTON' | translate" variant="secondary" (onClick)="onLogout()" class="ml-auto"></je-button
        ></span>
    </je-message-box>
</div>
